import styled from "styled-components"

export const ErrorMessageStyled = styled.div`
  width: 100%;
  margin-top: .25rem;
  font-size: 70%;
  color: #aa1e4b;
`